import { mergeColumnVisibilityWithAuditDefaults } from './tabulatorAuditColumns';
import { uiT } from './uiTranslate';

/** Kanonické poradie stĺpcov (vrátane technických) pre bezpečnú migráciu masiek. */
export const COMPANY_LIST_CANONICAL_FIELD_ORDERS = Object.freeze({
  MaintenanceCompanyCardList: Object.freeze([
    'rowSelection',
    'editor',
    'id',
    'name',
    'defined_id',
    'address',
    'tel_number',
    'fax',
    'email',
    'web_address',
    'contact_person',
    'description',
    'validity',
    'created_at',
    'updated_at',
  ]),
  MaintenanceCompanyContactList: Object.freeze([
    'rowSelection',
    'editor',
    'id',
    'name',
    'address',
    'tel_number',
    'fax',
    'email',
    'web_address',
    'contact_person',
    'description',
    'validity',
    'created_at',
    'updated_at',
  ]),
  MaintenanceCompanyCertificateList: Object.freeze([
    'rowSelection',
    'editor',
    'id',
    'name',
    'defined_id',
    'address',
    'tel_number',
    'fax',
    'email',
    'web_address',
    'contact_person',
    'description',
    'validity',
    'created_at',
    'updated_at',
  ]),
  MaintenanceCompanyCertRecordList: Object.freeze([
    'rowSelection',
    'editor',
    'id',
    'name',
    'defined_id',
    'types',
    'address',
    'tel_number',
    'fax',
    'email',
    'web_address',
    'contact_person',
    'description',
    'validity',
    'created_at',
    'updated_at',
  ]),
});

const DEFAULT_VISIBILITY_BY_PAGE = Object.freeze({
  MaintenanceCompanyCardList: Object.freeze({
    id: true,
    name: true,
    defined_id: true,
    address: true,
    tel_number: true,
    fax: true,
    email: true,
    web_address: true,
    contact_person: true,
    description: true,
    validity: true,
    created_at: true,
    updated_at: true,
  }),
  MaintenanceCompanyContactList: Object.freeze({
    id: true,
    name: true,
    address: true,
    tel_number: true,
    fax: true,
    email: true,
    web_address: true,
    contact_person: true,
    description: true,
    validity: true,
    created_at: true,
    updated_at: true,
  }),
  MaintenanceCompanyCertificateList: Object.freeze({
    id: true,
    name: true,
    defined_id: true,
    address: true,
    tel_number: true,
    fax: true,
    email: true,
    web_address: true,
    contact_person: true,
    description: true,
    validity: true,
    created_at: true,
    updated_at: true,
  }),
  MaintenanceCompanyCertRecordList: Object.freeze({
    id: true,
    name: true,
    defined_id: true,
    types: true,
    address: true,
    tel_number: true,
    fax: true,
    email: true,
    web_address: true,
    contact_person: true,
    description: true,
    validity: true,
    created_at: true,
    updated_at: true,
  }),
});

export const COMPANY_LIST_VALIDITY_FILTER_OPTIONS = Object.freeze([
  { get label() { return uiT('Common.Active'); }, value: 'Aktívny' },
  { get label() { return uiT('Status.Excluded'); }, value: 'Vyradený' },
]);

export function getCompanyListCanonicalFieldOrder(maskPage) {
  return COMPANY_LIST_CANONICAL_FIELD_ORDERS[maskPage] ?? null;
}

export function getCompanyListDefaultColumnVisibility(maskPage) {
  const base = DEFAULT_VISIBILITY_BY_PAGE[maskPage];
  return base ? { ...base } : {};
}

export function mergeCompanyListColumnVisibilityFromSaved(maskPage, saved) {
  const defaults = DEFAULT_VISIBILITY_BY_PAGE[maskPage];
  if (!defaults) return saved && typeof saved === 'object' ? { ...saved } : {};
  return mergeColumnVisibilityWithAuditDefaults(defaults, saved);
}

export function applyCompanyListDataColumnVisibility(table, maskPage, visibility) {
  if (!table) return;
  const defaults = DEFAULT_VISIBILITY_BY_PAGE[maskPage];
  if (!defaults) return;
  for (const field of Object.keys(defaults)) {
    if (visibility[field] === false) table.hideColumn?.(field);
    else table.showColumn?.(field);
  }
}

/** Client-side preview filter (mntn005/007 embedded dashboard). */
export function companyMaintenanceCertificatePreviewFilter(data, filterParams) {
  const certs = data?.maintenance_company_certificates;
  const end = certs?.length > 0 ? new Date(certs[0].end_of_validity) : null;
  const period = filterParams?.time_period;
  if (period === 'after') {
    return certs?.length === 0 || (end && end < new Date());
  }
  if (period === '15') {
    const limit = new Date();
    limit.setDate(limit.getDate() + 15);
    return certs?.length > 0 && end && end <= limit && end > new Date();
  }
  if (period === '30') {
    const limit = new Date();
    limit.setDate(limit.getDate() + 30);
    return certs?.length > 0 && end && end <= limit && end > new Date();
  }
  if (period === 'others') {
    const limit = new Date();
    limit.setDate(limit.getDate() + 30);
    return certs?.length > 0 && end && end > limit;
  }
  return false;
}
